$(document).on('turbo:load', function() {

  $('.brand-scoreboard-select').change(function() {
    // Also for brand groups

    const object_id = $(this).attr('object_id')
    // Determines route called
    const object_type = $(this).attr('object_type') ? 'sb_brand' : 'sb_brand_group'
    const timeline = $(this).val()
    const component = $('#scoreboard')
    const loadingDots = $(this).closest('.card').find('#brand-scoreboard-loading')

    component.find('.scoreboard-card').remove()
    loadingDots.removeClass('d-none')

    $.get(`/components/scoreboards/${object_type}?id=${object_id}&timeline=${timeline}`).done(function(html) {
      setTimeout(() => {
        loadingDots.addClass('d-none')
        component.replaceWith(html);
      }, 500);
    });

    const brandFunnelDropDown = $('.brand-funnel-graph-select')
    if (brandFunnelDropDown.val() !== timeline) brandFunnelDropDown.val(timeline).trigger('change')
  });
});